import { API_ROUTES } from "../constants";
import API from "./_api";

const ZoomAPI = class extends API {
  getSettings() {
    return this.request(API_ROUTES.ZOOM.GET_SETTINGS, {
      method: "GET",
    });
  }
};

export default ZoomAPI;
